<template>
  <a-form-item>
    <a-radio-group
      :value="value"
      class="mb-3"
      @change="onModeChange"
    >
      <a-radio value="students">{{ $t("accueil.eleves") }}</a-radio>
      <a-radio value="classes">{{ $t("accueil.classes") }}</a-radio>
      <a-radio value="levels">{{ $t("actualite.levels") }}</a-radio>
    </a-radio-group>

    <a-select
      v-if="value === 'students'"
      v-decorator="[
        'students',
        {
          rules: [
            {
              required: true,
              message: $t('paiement.eleveRequis'),
            },
          ],
        },
      ]"
      show-search
      :allowClear="true"
      mode="multiple"
      :placeholder="
        loadingStudents ? $t('all.loadingText') : $t('menu.listeEleves')
      "
      style="width: 100%"
      :disabled="loadingStudents"
      :filter-option="false"
      :default-active-first-option="false"
      :maxTagCount="5"
      :dropdownRender="renderStudentDropdown"
      @search="onStudentSearch"
      @change="onStudentChange"
      @dropdownVisibleChange="onStudentDropdown"
    >
      <a-select-option
        v-for="student in selectedStudentOptions"
        :key="student._id"
        :value="student._id"
        :title="student.displayName"
      >
        {{ student.displayName }}
      </a-select-option>
    </a-select>

    <a-select
      v-else-if="value === 'classes'"
      v-decorator="[
        'classes',
        {
          rules: [
            {
              required: true,
              message: $t('paiement.classRequis'),
            },
          ],
        },
      ]"
      show-search
      :allowClear="true"
      mode="multiple"
      :placeholder="
        loadingClasses ? $t('all.loadingText') : $t('sms.listeClasses')
      "
      style="width: 100%"
      :disabled="loadingClasses"
      option-filter-prop="children"
      :filter-option="filterOption"
      :maxTagCount="5"
    >
      <a-select-option
        v-for="classe in classes"
        :key="classe._id"
        :value="classe._id"
      >
        {{ classe.name }}
      </a-select-option>
    </a-select>
    <a-select
      v-if="value === 'levels'"
      v-decorator="[
        'levels',
        {
          rules: [
            { required: true, message: $t('enseignant.niveauxRequis') },
          ],
        },
      ]"
      show-search
      :allowClear="true"
      mode="multiple"
      :placeholder="$t('actualite.levels')"
      style="width: 100%"
      option-filter-prop="children"
      :filter-option="filterOption"
      :maxTagCount="5"
      @change="handleLevelChange"
    >
      <a-select-option
        v-for="(label, level) in levelSelectData"
        :key="level"
        :value="level"
      >
        {{ label }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>
<script>
/* eslint-disable */
import StudentVirtualList from "./StudentVirtualList.vue";

export default {
  name: "StudentSelectorFields",
  components: {
    StudentVirtualList,
  },
  props: {
    value: {
      type: String,
      default: "students",
    },
    studentList: {
      type: Array,
      default: () => [],
    },
    classes: {
      type: Array,
      default: () => [],
    },
    studentsData: {
      type: Object,
      default: () => ({}),
    },
    levelSelectData: {
      type: Object,
      default: () => ({}),
    },
    loadingStudents: {
      type: Boolean,
      default: false,
    },
    loadingClasses: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      studentSearch: "",
      selectedStudentIds: [],
    };
  },
  computed: {
    studentOptions() {
      return (this.studentList || []).map((s) => {
        const displayName = `${s.firstName || ""}${
          s.middleName ? " " + s.middleName : ""
        } ${s.lastName || ""}`
          .replace(/\s+/g, " ")
          .trim();
        return {
          _id: s._id,
          displayName,
          searchText: displayName.toLowerCase(),
        };
      });
    },
    filteredStudentOptions() {
      const query = (this.studentSearch || "").trim().toLowerCase();
      if (!query) return this.studentOptions;
      return this.studentOptions.filter((s) => s.searchText.includes(query));
    },
    selectedStudentOptions() {
      if (!this.selectedStudentIds.length) return [];
      const map = {};
      this.studentOptions.forEach((s) => {
        map[s._id] = s;
      });
      return this.selectedStudentIds.map((id) => map[id]).filter(Boolean);
    },
  },
  methods: {
    onModeChange(e) {
      this.studentSearch = "";
      this.selectedStudentIds = [];
      this.$emit("input", e.target.value);
      this.$emit("change", e.target.value);
    },
    onStudentSearch(value) {
      this.studentSearch = value || "";
    },
    onStudentChange(ids) {
      this.selectedStudentIds = ids || [];
    },
    onStudentDropdown(open) {
      if (!open) this.studentSearch = "";
    },
    getParentForm() {
      let parent = this.$parent;
      while (parent) {
        if (parent.form && typeof parent.form.setFieldsValue === "function") {
          return parent.form;
        }
        parent = parent.$parent;
      }
      return null;
    },
    toggleStudent(id) {
      const ids = this.selectedStudentIds.slice();
      const index = ids.indexOf(id);
      if (index === -1) ids.push(id);
      else ids.splice(index, 1);
      this.selectedStudentIds = ids;
      const form = this.getParentForm();
      if (form) form.setFieldsValue({ students: ids });
    },
    renderStudentDropdown() {
      return this.$createElement(StudentVirtualList, {
        props: {
          items: this.filteredStudentOptions,
          selectedIds: this.selectedStudentIds,
          loading: this.loadingStudents,
        },
        on: {
          toggle: this.toggleStudent,
        },
      });
    },
    handleLevelChange(selectedLevels) {
      const studentsInLevels = [];

      selectedLevels.forEach((level) => {
        const levelClasses = this.classes.filter(
          (cls) => cls.level.toString() === level.toString()
        );

        levelClasses.forEach((cls) => {
          const classStudents = this.studentsData[cls._id] || [];
          studentsInLevels.push(...classStudents.map((s) => s._id));
        });
      });

      this.$emit("level-students-change", studentsInLevels);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
